//import App from '../../components/nutrition/App'

import customStore from './store'
import modules from './store/modules'

import mixin from './mixin'

// This is your plugin object. It can be exported to be used anywhere.
const BFTNutrition = {
    customStore,
    // The install method is all that needs to exist on the plugin object.
    // It takes the global Vue object as well as user-defined options.
    install (Vue, { store }) {
        store.registerModule('Global', modules.Global)
        store.registerModule('Ingredients', modules.Ingredients)
        store.registerModule('Recipes', modules.Recipes)
        store.registerModule('Foods', modules.Foods)
        store.registerModule('Recipe', modules.Recipe)
        store.registerModule('Meals', modules.Meals)
        store.registerModule('Meal', modules.Meal)
        store.registerModule('Streams', modules.Streams)
        store.registerModule('Methods', modules.Methods)
        store.registerModule('MealPlan', modules.MealPlan)
        store.registerModule('MealPlans', modules.MealPlans)
        store.registerModule('ShoppingList', modules.ShoppingList)
        store.registerModule('Settings', modules.Settings)
        // Vue.prototype.$sessionStore = customStore
        //Vue.component('nutrition-app', App)

        // We call Vue.mixin() here to inject functionality into all components.
        Vue.mixin(mixin)
    }
}

export default BFTNutrition
